import { useContext } from 'react'
//Context
import { appContext } from "../../AppContext";

const FetchType = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
};

//options.method = GET, POST, PUT, DELETE
//options.url = the url to the api
//options.body = for POST the object you want to send (this will be JSON.stringyfied)
//onDataLoaded = this method will be fired when fetch is done (isSuccess, result)
export function useFetch() {
    const [appState] = useContext(appContext);

    function doFetch(url, method, body, stopProcessing) {
        if (method === undefined) {
            method = FetchType.GET;
        }
        return preformFetch(url, method, body, stopProcessing);
    }

    async function preformFetch(url, method, body, stopProccessing) {
        const headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'CustomLanguageId' : appState.user?.languageId ?? 1
        });

        return await fetch(appState.baseUrl + url, {
            method: method,
            headers: headers,
            mode: "cors",
            credentials: "include",
            body: JSON.stringify(body)
        })
            .then((response) => processResponse(response, stopProccessing))
            .catch(error => {
                console.error(error);
                return { isSuccess: false, result: error };
            });
    }

    async function processResponse(response, stopProcessing) {
        if (stopProcessing) {
            return { isSuccess: response.ok, result: response }
        }
        let json = ""
        try {
            json = await response.json();
        }
        catch (error) {
            console.error("Failed", error);
            return { isSuccess: false, result: response }
        }

        return { isSuccess: response.ok, result: json }
    }

    return [doFetch, FetchType]
}